import React from "react";
import PropTypes from "prop-types";
import BrokerSection from "./BrokerSection";
import BrokerField from "./BrokerField";
import BrokerLanguageField from "./BrokerLanguageField";

const BrokerAdmin = ({ translateFn }) => {
  return (
    <BrokerSection
      title={translateFn("adminContact")}
      translateFn={translateFn}
    >
      <BrokerField translateFn={translateFn} name={"adminContactFullName"} />
      <BrokerField
        translateFn={translateFn}
        name={"adminEmailAddress"}
        extraProps={{ type: "email" }}
      />
      <BrokerField translateFn={translateFn} name={"adminPhoneNumber"} />
      <BrokerLanguageField
        translateFn={translateFn}
        name={"adminContactLanguageCode"}
      />
    </BrokerSection>
  );
};

BrokerAdmin.propTypes = {
  translateFn: PropTypes.func.isRequired,
};

export default BrokerAdmin;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/formSections/BrokerAdmin.js